<template>
  <div class="city-contain">
    <div class="top-box">
      <div class="t-name">{{name}}</div>
      <div class="t-sort">
        排序
        <img
          class="s-img"
          src="../assets/index/sort_up.png"
          v-if="sortType==='sortDown'"
          @click="handleSort('sortUp')"
        />
        <img
          class="s-img"
          src="../assets/index/sort_down.png"
          v-if="sortType==='sortUp'"
          @click="handleSort('sortDown')"
        />
      </div>
    </div>
    <div v-for="(item,index) in rankList" :key="1*index+1">
      <div class="city-box" v-if="showAll || index < firstSize">
        <div class="city-name">{{1*index+1}}&#160;、{{item.name}}</div>
        <div class="right-box">
          <div class="mark">{{item.score}}分</div>
        </div>
      </div>
    </div>
    <div class="more-box" @click="showAll = true" v-if="!showAll && rankList.length > firstSize">
      <span>展开所有排名</span>
      <img src="../assets/guideSystem/show_more.png" />
    </div>
  </div>
</template>

<script>
    export default {
        name: 'rankCharts',
        props: {
            rankList: Array,
            firstSize: {
                type: Number,
                default: () => {
                    return 5; // 默认显示5个
                }
            },
            sort: {
                type: String,
                default: () => {
                    return 'sortDown'; // 默认降序
                }
            },
            name: {
                type: String,
                default: () => {
                    return ''; // 默认降序
                }
            }
        },
        data () {
            return {
                showAll: false,
                sortType: ''
            };
        },
        computed: {
            tmpSort: {
                get () {
                    return this.sort;
                },
                set (val) {
                    this.sortType = val
                }
            }
        },
        mounted () {
            this.showAll = false
            this.sortType = this.tmpSort
        },
        methods: {
            handleSort (type) {
                this.sortType = type;
                this.rankList.reverse();
                this.showAll = false;
            }
        }
    };
</script>
<style lang="less" scoped>
.city-contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .top-box {
    width: 100%;
    padding: 19px 0;
    display: flex;
    justify-content: space-between;
    .t-name {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .t-sort {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(51, 51, 51, 1);
      display: flex;
      align-items: center;
      .s-img {
        width: 14px;
        height: 12px;
        margin-left: 3px;
      }
    }
  }
  .city-box {
    border-bottom: 1px solid #eeeeee;
    height: 34px;
    width: 100%;
    display: flex;
    align-items: center;
    .city-name {
      display: flex;
      // justify-content: flex-end;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      white-space: nowrap;
    }
    .right-box {
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      width: 100%;
      .mark {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-left: 12px;
        white-space: nowrap;
      }
    }
  }
  .more-box {
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #9b9b9b;
    img {
      height: 4px;
      width: 7px;
      margin-left: 3px;
    }
  }
}
</style>
